
import React from 'react'
import { Title, SignInButton, SignOutButton, SignUpButton } from '../../Components'
import { useAuth } from '../../firebase/AuthContext'
import { useSelector } from 'react-redux'
import { selectAuthUser, selectIsAuthenticated, selectAuthLoading } from '../../store/slices/authSlice'
import styles from './Header.module.css'

const Header = (props) => {
    const { headerComponent=true, 
            title='App',
            headerBackground = 'lightgray',
            headerPadding = '10px',
            headerBorderBottom = '1px solid darkgray',
            titleColor = 'black',
            headerHeight = '60px' } = props
    // Context (fallback) と Redux の両方を利用。Redux があれば Redux を優先
    const ctx = useAuth() || { isAuthenticated:false, loading:true, user:null }
    const rUser = useSelector(selectAuthUser)
    const rIs = useSelector(selectIsAuthenticated)
    const rLoading = useSelector(selectAuthLoading)
    const isAuthenticated = rIs ?? ctx.isAuthenticated
    const loading = rLoading ?? ctx.loading
    const user = rUser || ctx.user

    if (!headerComponent) return null

    return (
        <div
            className={styles.header}
            style={{
                backgroundColor: headerBackground,
                padding: headerPadding,
                borderBottom: headerBorderBottom,
                '--header-height': headerHeight,
                '--header-padding': headerPadding,
                height: `var(--header-height, ${headerHeight})`
            }}>
            <Title text={title} />
            <div style={{ display: 'flex', gap: '8px', marginLeft: 'auto', alignItems:'center' }}>
                {/* ユーザー表示 (未ログイン時はゲスト) */}
                <span style={{ fontSize: '0.85rem', color: titleColor, opacity:0.8 }}>
                    {isAuthenticated && user ? (user.displayName || user.email) : 'ゲスト'}
                </span>
                {/* ボタン出し分け */}
                {loading ? (
                    <span style={{ fontSize: '0.75rem', color: titleColor, opacity:0.6 }}>...</span>
                ) : (
                    isAuthenticated ? (
                        <SignOutButton />
                    ) : (
                        <>
                            <SignInButton />
                            <SignUpButton />
                        </>
                    )
                )}
            </div>
        </div>
    )
}

export default Header
